import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { PriorityResponse } from '@/types/apps/priority.type';

import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface PriorityServiceGraphQLInterface {}

type PriorityListResponse = GqlListResponse<PriorityResponse>;

export class PriorityGraphQLService
    extends BaseService
    implements PriorityServiceGraphQLInterface
{
    public getEntityName(): string {
        return 'priority';
    }

    public getFields(): Record<string, any> {
        return {
            id: true,
            name: true,
            description: true,
        };
    }

    public async index(query: string): Promise<PriorityListResponse> {
        return this.fetchGqlList<PriorityListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById()) {
            return {};
        }

        return {
            // getFilterByRole: {
            //     inputType: 'input',
            //     key: 'id',
            //     operator: '=',
            //     value: this.getQueryById(),
            // },
        };
    }
}
